<mat-selection-list hideSingleSelectionIndicator [multiple]="false">
  <mat-list-option
    *ngFor="let contextOption of contextOptions; trackBy: trackByContextOption"
    (click)="dialogRef.close(contextOption)"
    >{{ contextOption.label }}</mat-list-option
  >
</mat-selection-list>
